import { UPLOAD_CONFIG, ERROR_MESSAGES, API_BASE_URL } from '../constants';

/**
 * 验证文件类型和大小
 * @param {File} file - 要验证的文件
 * @returns {Object} - 验证结果 {isValid: boolean, error: string}
 */
export const validateFile = (file) => {
  if (!file) {
    return { isValid: false, error: '请选择文件' };
  }

  // 检查文件类型
  if (!UPLOAD_CONFIG.ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return { isValid: false, error: ERROR_MESSAGES.INVALID_FILE_TYPE };
  }

  // 检查文件扩展名（额外安全检查）
  const fileName = file.name.toLowerCase();
  const hasValidExtension = UPLOAD_CONFIG.ALLOWED_EXTENSIONS.some(ext => 
    fileName.endsWith(ext)
  );
  
  if (!hasValidExtension) {
    return { isValid: false, error: ERROR_MESSAGES.INVALID_FILE_TYPE };
  }

  // 检查文件大小
  if (file.size > UPLOAD_CONFIG.MAX_FILE_SIZE) {
    return { isValid: false, error: ERROR_MESSAGES.FILE_TOO_LARGE };
  }

  return { isValid: true, error: null };
};

/**
 * 生成完整的头像URL
 * @param {string} avatarPath - 头像路径
 * @returns {string} - 完整的URL
 */
export const getAvatarUrl = (avatarPath) => {
  if (!avatarPath) {
    return UPLOAD_CONFIG.DEFAULT_AVATAR;
  }

  // 如果已经是完整URL，直接返回
  if (avatarPath.startsWith('http://') || avatarPath.startsWith('https://')) {
    return avatarPath;
  }

  // 如果是相对路径，拼接API基础URL
  if (avatarPath.startsWith('/')) {
    return `${API_BASE_URL}${avatarPath}`;
  }

  // 默认情况
  return `${API_BASE_URL}/${avatarPath}`;
};

/**
 * 创建文件预览URL
 * @param {File} file - 文件对象
 * @returns {Promise<string>} - 预览URL
 */
export const createPreviewUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = () => reject(new Error('文件读取失败'));
    reader.readAsDataURL(file);
  });
};

/**
 * 清理blob URL，防止内存泄漏
 * @param {string} url - 要清理的URL
 */
export const cleanupBlobUrl = (url) => {
  if (url && url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
};